var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { map } from 'rxjs/operators';
import { NGXLogger } from 'ngx-logger';
import { ApiService } from '../../service/api.service';
import { ListService, Predicate } from '../list/list.service';
import { ConditionService } from '../../service/condition.service';
var ItemModalService = /** @class */ (function (_super) {
    __extends(ItemModalService, _super);
    function ItemModalService(logger, api, cond) {
        var _this = _super.call(this, logger, api, cond) || this;
        _this.logger = logger;
        _this.api = api;
        _this.cond = cond;
        _this.baseGroupName = '$itemModalGroup';
        _this._subject = new BehaviorSubject({});
        return _this;
    }
    ItemModalService.prototype.initQuery = function () {
        _super.prototype.initQuery.call(this);
        _super.prototype.getQuery.call(this, { predicateList: [Object.assign(new Predicate(), { name: 'item_type', values: [1, 2], operator: 'in' })] }, _super.prototype.getGroupName.call(this));
        this._subject.next({ firstChange: true, value: {} });
    };
    ItemModalService.prototype.getItemType = function () {
        var _this = this;
        this.baseUrl = '/v1/gen/ec-code-m-service?query={"predicateList":[{"name":"ec_code_category_m.name","value":"ecItemType","operator":"eq"}],"orderByList":[{"name":"key","direction":"asc"}],"limit":100}';
        return _super.prototype.getRecord.call(this).pipe(map(function (data) {
            var options = [];
            for (var _i = 0, _a = data.items; _i < _a.length; _i++) {
                var item = _a[_i];
                options.push({ code: item.key, display: item.label });
            }
            _this.logger.debug('options:', options);
            return options;
        }));
    };
    ItemModalService.prototype.getItemCategory = function () {
        var _this = this;
        this.baseUrl = '/v1/gen/ec-item-category-m-service?query={"predicateList":[],"orderByList":[{"name":"id","direction":"asc"}],"limit":100}';
        return _super.prototype.getRecord.call(this).pipe(map(function (data) {
            var options = [];
            for (var _i = 0, _a = data.items; _i < _a.length; _i++) {
                var item = _a[_i];
                options.push({ code: item.id, display: item.label });
            }
            _this.logger.debug('options:', options);
            return options;
        }));
    };
    ItemModalService.prototype.getList = function () {
        var _this = this;
        var q = _super.prototype.getQuery.call(this, {}, _super.prototype.getGroupName.call(this));
        this.baseUrl = '/v1/gen/ec-item-m-price-view-api?query=' + JSON.stringify(q);
        _super.prototype.getRecord.call(this).subscribe(function (data) {
            _this.logger.debug('data:', data);
            _this._subject.next({ firstChange: false, value: data });
        });
    };
    Object.defineProperty(ItemModalService.prototype, "observable", {
        get: function () {
            return this._subject.asObservable();
        },
        enumerable: true,
        configurable: true
    });
    ItemModalService.prototype.setConditionQuery = function () {
    };
    ItemModalService.prototype.setCondition = function (data, groupName, key) {
        if (data === void 0) { data = {}; }
        if (key === void 0) { key = 'searchRec'; }
    };
    ItemModalService.prototype.getCondition = function (groupName) {
        return undefined;
    };
    ItemModalService.decorators = [
        { type: Injectable }
    ];
    /** @nocollapse */
    ItemModalService.ctorParameters = function () { return [
        { type: NGXLogger },
        { type: ApiService },
        { type: ConditionService }
    ]; };
    return ItemModalService;
}(ListService));
export { ItemModalService };
//# sourceMappingURL=item-modal.service.js.map